import React from "react";

const TextField3 = ({
  placeholder,
  name,
  className,
  validation,
  onBlur,
  onKeyPress,
  phoneStyle,
  value,
  id,
  onChange,
  maxlength,
  onKeyDown,
  type
}) => {
  return (
    <>
      <input
        type={type}
        name={name}
        className={className}
        placeholder={placeholder}
        ref={validation}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        style={phoneStyle}
        defaultValue={value}
        id={id}
        maxLength={maxlength}
        onKeyDown={onKeyDown}
      />
    </>
  );
};
export default TextField3;
